//
// LegendItem.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/DataVisualization";
import "../core/DiscreteLegendEntryType";
import "../core/DiscreteLegendEntryFillShape";
import "../core/styles/FillAttributes";
import "./LegendItemDisplay";
import "../core/styles/MarkerAttributes";
import "../core/styles/LineAttributes";
import "../core/styles/TextAttributes";

var LegendItem = createModule("gtl::LegendItem", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization"], EventDispatcher, [
    ,
    {
        fillShape: 4,
        fillAttributes: 1,
        markerAttributes: 1,
        outlineAttributes: 1,
        textAttributes: 1,
        fillDisplay: 1,
        lineAttributes: 1,
        labelAttributes: 1,
        label: 7,
        text: 7,
        type: 4,
        filledOutlinedMarker: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LegendItem;
